import React, { FunctionComponent } from 'react';

import clsx from 'clsx';

import styles from './SliderPagination.module.scss';

type ClassKey = 'root' | 'list' | 'item' | 'button';

type SliderPaginationProps = {
    scrollSnaps: number[];
    scrollTo(index: number): void;
    selectedIndex: number;
    classes?: Classes<ClassKey>;
};
export const SliderPagination: FunctionComponent<SliderPaginationProps> = (props) => {
    const { scrollSnaps, scrollTo, selectedIndex, classes } = props;

    return (
        <div className={clsx(styles.root, classes?.root)}>
            <ul className={clsx(styles.list, classes?.list)}>
                {scrollSnaps.map((_, index) => (
                    <li key={index} className={clsx(styles.item, classes?.item)}>
                        <button
                            className={clsx(
                                styles.button,
                                selectedIndex === index && styles.isActive,
                                classes?.button,
                            )}
                            type="button"
                            onClick={() => scrollTo(index)}
                            aria-label={`Слайд №${index + 1}`}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};
